import { useIntl } from "react-intl";

import { ReactComponent as InfoCircleIcon } from "assets/images/iconsV2/info-circle-sm.svg";
import Badge from "components/v2/Badge/Badge";
import { classNames } from "helpers/commonHelpers";

import "./SectionHintBadge.scss";

export type SectionHintAppearance = "brandHint" | "gray";

type SectionHintBadgeProps = {
  messageId: string;
  defaultMessage: string;
  appearance?: SectionHintAppearance;
};

export default function SectionHintBadge({
  messageId,
  defaultMessage,
  appearance = "brandHint",
}: Readonly<SectionHintBadgeProps>) {
  const intl = useIntl();
  const isBrandHint = appearance === "brandHint";

  return (
    <div
      className={classNames("rfv2-section-hint-badge", {
        "rfv2-section-hint-badge--brand": isBrandHint,
        "rfv2-section-hint-badge--gray": !isBrandHint,
      })}
    >
      <Badge
        type="category-badge"
        size="sm"
        color={isBrandHint ? "brand" : "gray"}
        variant={isBrandHint ? "icon-leading" : "text-only"}
        icon={isBrandHint ? <InfoCircleIcon className="rfv2-section-hint-badge__icon" /> : undefined}
        label={intl.formatMessage({
          id: messageId,
          defaultMessage,
        })}
      />
    </div>
  );
}
